// extracted by mini-css-extract-plugin
export default {"paymentTermsLabel":"payment-terms_paymentTermsLabel__CUage","rowWrapper":"payment-terms_rowWrapper__yEDEs","fieldWrapper":"payment-terms_fieldWrapper__UMJuz"};